import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './app/core/modules/core.module';

import { registerLicense } from '@syncfusion/ej2-base';
import { AppRoutingModule } from './app/app-routing.module';

// Syncfusion License
registerLicense('@32312e312e3335i1+1ysDC+/5aAtyu+SVtxC9Ubs57GEfZ6c88GCG4ExE=');

bootstrapApplication(AppComponent, {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    importProvidersFrom(
      BrowserAnimationsModule,
      AppRoutingModule,
      CoreModule
    ),
  ],
}).catch(err => console.error(err));